import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { Select } from "components"
import classes from "./OfsBranches.module.scss"

const OfsBranches = props => {
  const { form, setForm } = props

  const [t] = useTranslation()

  const cashierBranches =
    useSelector(state => state.userAccountInfo.cashierBranches)

  const handleChangeBranch = (select) => {
    setForm(prev => ({
      ...prev,
      branch: select
    }))
  }

  const branchOptions =
    cashierBranches.map(sb => ({
      label: sb.name,
      value: sb._id
    }))

  if (cashierBranches.length <= 1) return null

  return (
    <div className={classes["container"]}>
      <Select
        value={form.branch}
        isClearable
        isSearchable={false}
        label={t("شعبه")}
        noOptionsMessage={() => null}
        options={branchOptions}
        onChange={handleChangeBranch}
      />
    </div>
  )
}

export default OfsBranches